import { useQuery } from '@tanstack/react-query'
import { listVendors } from '../services/purchaseApi'

/**
 * REFERENCE PORT — the day-one template for the AI-assisted port loop.
 *
 * Shows the canonical pattern every junior follows:
 *   - server state via TanStack Query (replaces fetch-on-mount + watch-refetch)
 *   - data fetched through the ported service (no axios in the component)
 *   - presentational markup with Tailwind (design-system components land in Phase 0)
 *
 * Port checklist for a new screen:
 *   1. Open the Vue file + live screen side-by-side.
 *   2. Claude Code drafts JSX (template -> JSX, ref -> useState, computed -> useMemo).
 *   3. Wire to the ported service; match styling against the live screen.
 *   4. Playwright parity test green -> PR -> Lead review -> merge.
 */
export function VendorListPage() {
  const { data: vendors, isLoading, error } = useQuery({
    queryKey: ['purchase', 'vendors'],
    queryFn: listVendors,
  })

  if (isLoading) return <div className="text-sm text-gray-500">Loading vendors…</div>
  if (error) return <div className="text-sm text-red-600">Failed to load vendors.</div>

  return (
    <div>
      <h1 className="mb-4 text-xl font-semibold">Vendors</h1>
      <table className="w-full border-collapse text-sm">
        <thead>
          <tr className="border-b text-left text-gray-500">
            <th className="py-2">Name</th>
            <th className="py-2">GST</th>
            <th className="py-2">Payment terms</th>
            <th className="py-2">Email</th>
          </tr>
        </thead>
        <tbody>
          {vendors?.map((v) => (
            <tr key={v.id} className="border-b hover:bg-gray-50">
              <td className="py-2 font-medium">{v.name}</td>
              <td className="py-2">{v.gst_number ?? '—'}</td>
              <td className="py-2">{v.payment_terms ?? '—'}</td>
              <td className="py-2">{v.email ?? '—'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
